import Pathicon from "@pathwright/ui/src/components/pathicon/Pathicon"
import Text from "@pathwright/ui/src/components/ui/Text"
import View from "@pathwright/ui/src/components/ui/View"
import { WithCSS } from "@pathwright/ui/src/components/utils/styles"
import PropTypes from "prop-types"
import { css } from "styled-components"
import withLesson from "../lesson/withLesson"
import PathStepsAnimator from "./PathStepsAnimator"

export const PathSteps = ({
  lesson: queryLesson,
  propsLesson,
  expand,
  total,
  getStepLinkProps,
  renderStepChevron,
  onToggle
}) => {
  const lesson = propsLesson || queryLesson

  return (
    <View>
      {lesson && lesson.items.length > 0 && (
        <PathStepsAnimator
          expand={expand}
          steps={lesson.items}
          getStepLinkProps={getStepLinkProps}
          renderStepChevron={renderStepChevron}
        />
      )}
      <WithCSS
        as={View}
        css={css`
          padding: 5px 0;
          text-align: center;
          border-radius: 0 0 10px 10px;
        `}
      >
        <Text.Meta className="PathSteps-toggle" onClick={onToggle}>
          <Pathicon icon={`chevron-${expand ? "up" : "down"}`} />{" "}
          {expand ? "Hide" : "Show"} {total} steps
        </Text.Meta>
      </WithCSS>
    </View>
  )
}

PathSteps.displayName = "PathSteps"

PathSteps.propTypes = {
  // can be used instead of queried lesson
  propsLesson: PropTypes.object,
  // props for querying
  lessonSourceId: PropTypes.number,
  pathId: PropTypes.number.isRequired,
  schoolId: PropTypes.number.isRequired
}

// withLesson (compose(withPath, …)) runs the Path query; build once so the
// component identity is stable across renders (avoids remount / refetch churn).
const PathStepsWithPathQuery = withLesson((props) => <PathSteps {...props} />)
PathStepsWithPathQuery.displayName = "PathStepsWithPathQuery"

// withLesson queries the Path (see withPath)
// we'll allow passing propsLesson to skip queries
const PathStepsContainer = ({ propsLesson, onToggle, ...rest }) => {
  if (propsLesson) {
    return <PathSteps lesson={propsLesson} onToggle={onToggle} {...rest} />
  }

  return <PathStepsWithPathQuery onToggle={onToggle} {...rest} />
}

export default PathStepsContainer
